import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MonthlyLicensePurchaseDialogData } from "../../billing.interface";

@Component({
  selector: "app-monthly-license-purchase-dialog",
  templateUrl: "./monthly-license-purchase-dialog.component.html",
  styleUrls: ["./monthly-license-purchase-dialog.component.scss"],
  standalone: false,
})
export class MonthlyLicensePurchaseDialogComponent {
  public sendingRequest = false;
  public calculatedPrice = 0;
  public fullMonthPrice = 0;
  public proportionalPrice = 0;
  public daysInMonth = 0;
  public daysRemaining = 0;
  public nextPaymentDate: Date;
  public employeeCount: number;

  constructor(
    public dialogRef: MatDialogRef<MonthlyLicensePurchaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MonthlyLicensePurchaseDialogData,
  ) {
    this.employeeCount = this.data.defaultEmployeeCount || 0;
    this.calculatePrice();
    this.calculateNextPaymentDate();
  }

  calculatePrice = () => {
    const isLegacyBilling = this.data.billingMode === "legacy";
    const effectiveEmployeeCount = isLegacyBilling
      ? this.employeeCount
      : Math.max(this.employeeCount, 10);
    const basePrice = this.data.price || 0;
    this.fullMonthPrice = parseFloat(
      (basePrice * effectiveEmployeeCount).toFixed(2),
    );

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const subscriptionStartDate = this.data.subscriptionStartDate
      ? new Date(this.data.subscriptionStartDate)
      : today;
    subscriptionStartDate.setHours(0, 0, 0, 0);

    const year = subscriptionStartDate.getFullYear();
    const month = subscriptionStartDate.getMonth();

    const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
    const startDay = subscriptionStartDate.getDate();

    this.daysInMonth = daysInCurrentMonth;
    this.daysRemaining = daysInCurrentMonth - startDay + 1;

    const proportionalMultiplier = this.daysRemaining / daysInCurrentMonth;
    this.proportionalPrice = parseFloat(
      (this.fullMonthPrice * proportionalMultiplier).toFixed(2),
    );
    this.calculatedPrice = this.proportionalPrice;
  };

  calculateNextPaymentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    this.nextPaymentDate = new Date(year, month + 1, 0);
  };

  submit = () => {
    this.sendingRequest = true;
    const isLegacyBilling = this.data.billingMode === "legacy";
    const effectiveEmployeeCount = isLegacyBilling
      ? this.employeeCount
      : Math.max(this.employeeCount, 10);
    this.dialogRef.close({
      numberOfEmployees: effectiveEmployeeCount,
      proceed: true,
    });
  };

  close = () => this.dialogRef.close({ proceed: false });
}
